import { Component, computed, inject } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';
import { ImpersonationStore } from 'shared';

import { SidebarStore } from '../sidebar.store';

@Component({
  selector: 'app-impersonation-banner',
  standalone: true,
  imports: [Tooltip],
  template: `
    @if (isImpersonating()) {
      <!-- Fixed banner below header, aligned with main content -->
      <div
        class="fixed top-16 left-0 right-0 h-10 bg-amber-100 border-b border-amber-200 z-30 transition-all duration-300"
        [class.lg:left-64]="!sidebarStore.isCollapsed()"
        [class.lg:left-16]="sidebarStore.isCollapsed()"
      >
        <div class="flex items-center justify-between px-4 h-full">
          <!-- Icon: user icon -->
          <i class="pi pi-user text-amber-700 mr-2 text-lg"></i>

          <!-- User info with truncation and tooltip -->
          <div class="flex-1 min-w-0">
            <span
              class="text-amber-900 text-sm sm:text-base truncate block"
              [pTooltip]="fullUserInfo()"
              tooltipPosition="bottom"
              [showDelay]="300"
            >
              <span class="hidden sm:inline">Viewing as </span>
              <span class="font-medium">{{ userName() }}</span>
              <span class="hidden md:inline"> ({{ userEmail() }})</span>
            </span>
          </div>

          <!-- Exit button -->
          <button
            type="button"
            (click)="handleExit()"
            class="ml-4 text-amber-900 hover:text-amber-950 font-medium text-sm sm:text-base hover:underline focus:outline-none focus:underline"
            aria-label="Exit impersonation mode"
          >
            Exit
          </button>
        </div>
      </div>

      <!-- Spacer to push content down -->
      <div class="h-10"></div>
    }
  `,
})
export class ImpersonationBannerComponent {
  protected impersonationStore = inject(ImpersonationStore);
  protected sidebarStore = inject(SidebarStore);

  protected isImpersonating = this.impersonationStore.isImpersonating;

  protected userName = computed(() => this.impersonationStore.impersonatedUser()?.name ?? '');

  protected userEmail = computed(() => this.impersonationStore.impersonatedUser()?.email ?? '');

  protected fullUserInfo = computed(() => {
    const user = this.impersonationStore.impersonatedUser();
    return user ? `${user.name} (${user.email})` : '';
  });

  protected handleExit(): void {
    // Calls endImpersonation() which triggers window.location.reload()
    // No confirmation needed (per user context 17-02)
    this.impersonationStore.endImpersonation();
  }
}
